import { ISystemMedication } from '../types';
import { HydraQueryParams, useHydraQuery } from './useHydraQuery';

export function useGetMedicationsQuery<D extends ISystemMedication[]>(
  params?: HydraQueryParams<D>
) {
  const { vars, options } = params || {};
  return useHydraQuery<D>('getMedications', '/api/medications', {
    vars,
    options,
  });
}
